import { render, staticRenderFns } from "./SwiperTypeSix.vue?vue&type=template&id=bf60717a&scoped=true&"
import script from "./SwiperTypeSix.vue?vue&type=script&lang=js&"
export * from "./SwiperTypeSix.vue?vue&type=script&lang=js&"
import style0 from "./SwiperTypeSix.vue?vue&type=style&index=0&id=bf60717a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf60717a",
  null
  
)

export default component.exports